export const formatIst = (value) => value ? new Date(value).toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' }) + ' IST' : 'Never';

export const toIstInput = (value) => {
  if (!value) return '';
  const date = new Date(new Date(value).getTime() + 330 * 60 * 1000);
  return Number.isNaN(date.getTime()) ? '' : date.toISOString().slice(0, 16);
};

export const fromIstInput = (value) => value ? new Date(`${value}:00+05:30`).toISOString() : null;

export const linkStatus = (link) => {
  if (link.archived_at) return 'Archived';
  if (link.is_active === false) return 'Inactive';
  if (link.expires_at && new Date(link.expires_at).getTime() <= Date.now()) return 'Expired';
  return link.short_code ? 'Active' : 'Legacy';
};
